import { gsap, Power1, Power4 , Power2, Power3} from "gsap";
$ = jQuery;

export function init(){
    var currentMousePos = {
        x: -1,
        y: -1
    };
    
    

    $(document).mousemove(function (event) {
        currentMousePos.x = event.pageX;
        currentMousePos.y = event.pageY;

        gsap.to($(".cursor-position__container"), {"left": currentMousePos.x + "px", "top": currentMousePos.y + "px"});

        if (($(event.target).hasClass("-cursor-readmore")) || ($(event.target).parents(".-cursor-readmore").length)) {
            $(".cursor-type").addClass("-readmore");
        } else {
            $(".cursor-type").removeClass("-readmore");
        }
        if ($(event.target).parents("#nav").length) {
            $(".cursor-type").addClass("big");
        } else {
            $(".cursor-type").removeClass("big");
        }
        if ($(event.target).parents(".result.clickable").length) {
            $(".cursor-type").addClass("play");
        } else {
            $(".cursor-type").removeClass("play");
        }

    });

}
